import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

import { UserRole } from '../models/enums/user-role.enum';
import { DeviceService, TokenService, LocalStorageService } from '../services';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // add token to request
    const tokenService = this.injector.get(TokenService);
    const deviceService = this.injector.get(DeviceService);

    const token = tokenService.token;
    const companyId = tokenService.user?.companyId;
    const deviceUid = deviceService.getDeviceUuid();
    const reseller = localStorage.getItem(LocalStorageService.RESELLER);

    if (token && request.url.includes(environment.baseUrl) && !request.headers.has('Authorization')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    if (deviceUid) {
      request = request.clone({
        setHeaders: {
          DeviceUid: deviceUid,
        },
      });
    }

    if (companyId && tokenService.isUserInOneOfRoles([UserRole.Admin])) {
      request = request.clone({ headers: request.headers.set('CompanyId', companyId) });
    }

    if (reseller) {
      request = request.clone({ headers: request.headers.set('Reseller', reseller) });
    }

    if (!request.headers.has('Accept')) {
      request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
    }

    // get token from response
    const responseToken = request.headers.get('X-Access-Token');
    if (responseToken && responseToken != null && responseToken !== '') {
      tokenService.setToken(responseToken);
    }

    return next.handle(request);
  }
}
